
declare global {
  interface Window {
    $: any;
    jQuery: any;
  }
}
import { Component, Vue } from "vue-property-decorator";
import { VMoney } from "v-money";
import "air-datepicker/dist/css/datepicker.min.css";
import moment from "moment";

const $ = require("jquery");
window.$ = $;
window.jQuery = $;
require("air-datepicker");

@Component({
  components: {
    Selectize: () => import("vue2-selectize"),
    Slick: () => import("vue-slick"),
    SortColumn: () => import("@/components/SortColumn.vue"),
  },
  directives: { money: VMoney },
  computed: {
    isMobile() {
      return window.innerWidth < 992;
    },
    filteredCompanies() {
      if (!(this as any).company.businessId) return (this as any).companies;
      return (this as any).companies.filter(
        (c: any) => c.businessId === (this as any).company.businessId
      );
    },
  },
})
export default class CompaniesAdd extends Vue {
  title: string = "Agregar Contrato";
  subtitle: string = "Introduzca los datos del contrato a dar de alta.";
  company: Record<string, any> = {
    name: "",
    rif: "",
    direction: "",
    floor: "",
    door_number: "",
    cap: "",
    handle_exclusion_contract: 0,
    countryId: "",
    renew_company: "",
    adminId: "",
    companyName: "",
    contractCode: "",
    currencies: [],
    branches: [],
    exclusions: [],
  };
  currentSort: Record<string, string> = {
    col: "name",
    dir: "asc",
  };
  subscriptor: any = {
    companyId: null,
    can_do_request: "",
    branches: [],
  };
  selectedSubscriptor: any = {
    id: "",
    firstName: "",
    lastName: "",
    suscriptor: {
      id: null,
      fullname: ""
    }
  };
  userSubscriptors: any = [];
  subscriptors: any = [];
  currencyId: number = 0;
  currency: any = {};
  currencies: any = [];
  totalBranches: any = [];
  companyReinsurers: any = [];
  reinsurers: any = [];
  branches: any = [];
  companies: any = [];
  countries: any = [];
  steps: Record<number, boolean> = {
    0: true,
    1: false,
    2: false,
  };
  selectizeOptions: Record<string, any> = {
    plugins: [{ name: "remove_button", options: { label: "", title: "Quitar ramo" }}],
    delimiter: ",",
    persist: true,
  };
  slickOptions: Record<string, any> = {
    slidesToShow: 3,
    centerPadding: "60px",
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false,
        },
      },
    ],
  };
  selected: any = [];
  subscriptorBranches: any = [];
  error: boolean = false;
  exclusions: any = [];
  exclusion: any = {};
  currentExclusion: number = 0;
  money: any = {
    decimal: ",",
    thousands: ".",
    prefix: "",
    suffix: "",
    precision: 0,
    masked: true,
  };
  businesses: any = [];
  renewCompanyData: any = {};
  errors: Record<string, string> = {};

  async mounted() {
    (this as any).$root.localizeDatepicker($);
  }

  async init() {
    const _this = this;
    $(".calendar").each(function (this: any) {
      let elem = $(this).find("input");
      elem.datepicker({
        language: "es",
        autoClose: true,
        onSelect: function onSelect(fd, date) {
          _this.company[elem.attr("model")] = moment(date).format("YYYY-MM-DD");
        },
      });
    });
    await this.loadCountries();
    await this.loadCompanies();
    await this.loadBusinesses();
    await this.loadBranches();
    await this.loadReinsurers();
    await this.loadCurrencies();
    await this.loadExclusions();
    if (this.$route.params.id) {
      this.loadCompany();
    }

    setTimeout(() => {
      this.calculatePercent();
    }, 1000);
  }

  addBranch(value) {
    const selectedIds = (value || []).map((v) => parseInt(v));

    this.company.branches = selectedIds.map((id) => {
      const existing = this.company.branches.find(
        (b) => parseInt(b.id) === id
      );
      if (existing) return existing;
      return {
        ...this.branches.find((b) => parseInt(b.id) === id),
        companies_branches: { _limit: 0 },
      };
    });

    this.totalBranches = selectedIds.map((id) => {
      const existing = this.totalBranches.find(
        (tb) => parseInt(tb.id) === id
      );
      if (existing) return existing;
      return {
        ...this.branches.find((b) => parseInt(b.id) === id),
        total: 0,
      };
    });

    this.$nextTick(() => {
      this.calculatePercent();
    });
  }

  totalPercent(id: any) {
    return 0;
  }

  isBranchChecked(reinsurer: any, value: string) {
    return (
      reinsurer &&
      reinsurer.branches &&
      reinsurer.branches.length &&
      reinsurer.branches.indexOf(value) >= 0
    );
  }

  selectAllBranches(value: boolean, index: number) {
    document
      .querySelectorAll(`[name="branches${index}[]"]`)
      .forEach((i: any) => (i.checked = value));
    this.calculatePercent();
  }

  branchName(id) {
    console.log("id", id);
    return this.branches.find((b) => parseInt(b.id) === parseInt(id)).title;
  }
  branch(index: string) {
    const _this: any = this;
    return _this.branches.find((b: any) => parseInt(b.id) === parseInt(index))
      .title;
  }

  clearFieldError(fieldName: string) {
    if (this.errors[fieldName]) {
      this.$delete(this.errors, fieldName);
    }
  }

  validateStep1() {
    const required = ["name", "rif", "direction", "cap"];
    for (let i: number = 0; i < required.length; i++) {
      if (!this.company[required[i]]) return false;
    }
    return true;
  }

  validateStep2() {
    const required = ["owner", "email"];
    for (let i: number = 0; i < required.length; i++) {
      if (!this.company[required[i]]) return false;
    }
    return true;
  }

  validateContract() {
    this.errors = {};
    let valid = true;

    if (!this.company.name || !this.company.name.trim()) {
      this.$set(this.errors, 'name', 'El nombre del contrato es obligatorio');
      valid = false;
    }

    if (!this.company.date_contract_aon) {
      this.$set(this.errors, 'date_contract_aon', 'La fecha de contrato es obligatoria');
      valid = false;
    }

    if (!this.company.date_request_from) {
      this.$set(this.errors, 'date_request_from', 'La fecha desde es obligatoria');
      valid = false;
    }

    if (!this.company.date_request_to) {
      this.$set(this.errors, 'date_request_to', 'La fecha hasta es obligatoria');
      valid = false;
    }

    if (this.company.date_request_from && this.company.date_request_to) {
      const from = moment(this.company.date_request_from);
      const to = moment(this.company.date_request_to);
      if (to.isBefore(from)) {
        this.$set(this.errors, 'dates', 'La fecha Hasta no puede ser anterior a la fecha Desde');
        valid = false;
      }
    }

    for (let b of this.totalBranches) {
      if (b.total !== 100) {
        this.$set(this.errors, 'totalBranches', `El porcentaje total del ramo "${b.title}" debe ser exactamente 100% (actual: ${b.total}%)`);
        valid = false;
        break;
      }
    }

    return valid;
  }

  move(index: number) {
    if (this[`validateStep${index}`]()) {
      (this.$refs.slick as any).goTo(index);
      this.steps[index] = true;
    }
  }

  changeLimit(value, branchId) {
    this.company.branches.push({
      id: parseInt(branchId),
      _limit: parseFloat(value),
    });
  }

  fillCompanyData(companyData) {
    this.company.companyName = companyData.selected.name;
    this.company.rif = companyData.selected.rif;
    this.company.direction = companyData.selected.direction;
    this.company.floor = companyData.selected.floor;
    this.company.cap = companyData.selected.cap;
    this.company.country = companyData.selected.country.title;
    this.company.owner = this.getOwnerName(companyData.selected.owners[0]);
    this.company.dni = companyData.selected.owners[0].dni;
    this.company.position = companyData.selected.owners[0].position;
    this.company.email = companyData.selected.owners[0].email;
    this.company.countryId = companyData.selected.countryId;
    this.company.businessId = companyData.selected.id;

    this.loadCompanies();
    this.loadSubscriptors();
  }

  getOwnerName(owner) {
    if (owner) {
      return owner.last_name && owner.last_name.trim()
        ? `${owner.name} ${owner.last_name}`
        : owner.name;
    } else {
      return "";
    }
  }

  async getContractdata() {
    if (!this.company.renew_company) return;

    const response: any = await (this.$root as any)._post(
      `companies/one/${this.company.renew_company}`,
      {
        models: "branches,admin,currencies,exclusions",
      }
    );
    this.renewCompanyData = response.data[0];

    if (this.renewCompanyData.branches && this.renewCompanyData.branches.length) {
      this.selected = this.renewCompanyData.branches.map((b) => b.id);

      this.company.branches = this.renewCompanyData.branches.map((b: any) => ({
        ...b,
        companies_branches: b.companies_branches || { _limit: 0 },
      }));

      this.totalBranches = this.company.branches.map((item: any) => ({
        ...item,
        total: 0,
      }));

      if (this.$refs.selectize) {
        (this.$refs.selectize as any).$el.selectize.setValue(
          this.selected.map((id: any) => String(id))
        );
      }
    }

    this.company.currencies = [];
    if (this.renewCompanyData.currencies && this.renewCompanyData.currencies.length) {
      for (let i in this.renewCompanyData.currencies) {
        this.currencies = this.currencies.filter(
          (c) => c.id !== this.renewCompanyData.currencies[i].id
        );
        this.company.currencies.push({
          ...this.renewCompanyData.currencies[i],
          can_do_request: true,
        });
      }
    }

    if (this.renewCompanyData.exclusions && this.renewCompanyData.exclusions.length) {
      this.company.exclusions = this.renewCompanyData.exclusions.map((e: any) => ({
        companyId: null,
        exclusionId: e.exclusionId || e.id,
        title: e.title,
        percent: e.percent || 0,
      }));
      const assignedIds = this.company.exclusions.map((e: any) => e.exclusionId);
      this.exclusions = this.exclusions.filter((e: any) => !assignedIds.includes(e.id));
    }

    await this.loadRenewSubscriptors();

    await this.$nextTick();
    await this.loadRenewReinsurers();
  }

  async loadRenewReinsurers() {
    try {
      const companyReinsurersResponse: any = await (this.$root as any)._get(
        `reinsurerscompanies/${this.company.renew_company}`
      );
      const companyReinsurers = companyReinsurersResponse.data;

      this.reinsurers.forEach((reinsurer: any, idx: number) => {
        this.$set(this.reinsurers[idx], 'checked', false);
        this.$set(this.reinsurers[idx], 'percent', 0);
        this.$set(this.reinsurers[idx], 'branches', []);
      });

      this.reinsurers.forEach((reinsurer: any, idx: number) => {
        companyReinsurers.forEach((companyReinsurer: any) => {
          if (companyReinsurer.reinsurerId == reinsurer.id) {
            this.$set(this.reinsurers[idx], 'percent', companyReinsurer.percent);
            this.$set(this.reinsurers[idx], 'checked', true);
            this.$set(this.reinsurers[idx], 'branches', companyReinsurer.branches ? JSON.parse(companyReinsurer.branches) : []);
          }
        });
      });

      this.$nextTick(() => {
        setTimeout(() => {
          this.reinsurers.forEach((reinsurer: any) => {
            if (reinsurer.checked && reinsurer.branches) {
              reinsurer.branches.forEach((b: any) => {
                if (typeof b === "object") {
                  let key = Object.keys(b)[0];
                  const checkbox = (document as any).getElementById(`branch-${reinsurer.id}${key}`);
                  const input = (document as any).getElementById(`branch-percent-${reinsurer.id}${key}`);
                  if (checkbox) checkbox.checked = true;
                  if (input) input.value = b[key];
                } else {
                  const checkbox = (document as any).getElementById(`branch-${reinsurer.id}${b}`);
                  const input = (document as any).getElementById(`branch-percent-${reinsurer.id}${b}`);
                  if (checkbox) checkbox.checked = true;
                  if (input) input.value = 100;
                }
              });
            }
          });
          this.calculatePercent();
        }, 500);
      });
    } catch (e) {
      console.log(e);
    }
  }

  async loadRenewSubscriptors() {
    const response = await (this.$root as any)._get(`subscriptors`, {
      companyId: this.company.renew_company,
      businessId: this.company.businessId || null
    });

    await this.loadSubscriptors();
    this.subscriptors = response.data;
  }

  async loadSubscriptors() {
    let response: any = await (this.$root as any)._get(`subscriptors`, {
      excludeCompanyId: this.company.renew_company || null,
      businessId: this.company.businessId || null
    });

    this.userSubscriptors = response.data;
  }

  asociateSubscriptor() {
    this.subscriptors.push(this.selectedSubscriptor);
    this.selectedSubscriptor = null;
  }

  removeSubscriptor(userSubscriptor: any) {
    this.subscriptors = this.subscriptors.filter(
      (s) => s.subscriptor.id !== userSubscriptor.subscriptor.id
    );

    this.userSubscriptors.push(userSubscriptor);
  }

  async save() {
    if (!this.validateContract()) return;

    let response: any = null;
    if (this.company.currencies.length === 0) {
      (this.$root as any).notify(
        "Debe asignar una moneda al contrato.",
        "error"
      );
      return false;
    }

    if (this.selected.length === 0) {
      (this.$root as any).notify("Debe asignar ramos al contrato.", "error");
      return false;
    } else {
      if (this.company.branches.length === 0) {
        (this.$root as any).notify(
          "Debe asignar limites a los ramos.",
          "error"
        );
        return false;
      } else {
        for (let i in this.company.branches) {
          if (this.company.branches[i]._limit == 0) {
            (this.$root as any).notify(
              "Debe asignar limites a los ramos.",
              "error"
            );
            return false;
          }
        }
      }
    }

    try {
      response = await (this.$root as any)._post("companies", this.company);
      let companyId = response.id;
      if (response) {
        for (let i: number = 0; i < this.company.branches.length; i++) {
          try {
            await (this.$root as any)._post("companiesbranches", {
              companyId: companyId,
              branchId: this.company.branches[i].id,
              _limit: this.company.branches[i]._limit
                .replace(/\./g, "")
                .replace(",", "."),
              allow_new_request: 1,
            });
          } catch (e) {
            console.log(e);
          }
        }

        for (let i: number = 0; i < this.reinsurers.length; i++) {
          try {
            if (this.reinsurers[i].checked) {
              let branches: any = [];
              document
                .querySelectorAll(`[name="branches${this.reinsurers[i].id}[]"]`)
                .forEach((i: any) => i.checked && branches.push(i.value));

              await (this.$root as any)._post(`reinsurerscompanies`, {
                reinsurerId: parseInt(this.reinsurers[i].id),
                companyId: companyId,
                percent: parseFloat(this.reinsurers[i].percent) || 100,
                branches: branches.map((b: any) => {
                  return {
                    [b]: (document as any).getElementById(
                      `branch-percent-${parseInt(this.reinsurers[i].id)}${b}`
                    ).value,
                  };
                }),
              });
            }
          } catch (e) {
          }
        }

        for (let i: number = 0; i < this.company.currencies.length; i++) {
          try {
            await (this.$root as any)._post("companiescurrencies", {
              companyId: companyId,
              currencyId: this.company.currencies[i].id,
              can_do_request: this.company.currencies[i].can_do_request,
            });
          } catch (e) {
            console.log(e);
          }
        }

        for (let i: number = 0; i < this.company.branches.length; i++) {
          try {
            await (this.$root as any)._put(
              `companiesbranches/${companyId}/${this.company.branches[i].id}`,
              {
                _limit: this.company.branches[i]._limit,
                allow_new_request: true,
              }
            );
          } catch (e) {
            console.log(e);
          }
        }

        this.subscriptors.forEach(async (subscriptorToSave) => {
          await (this.$root as any)._post(`companies/${companyId}/subscriptors/${subscriptorToSave.subscriptor.id}`);

          let data = {
            ...subscriptorToSave.subscriptor,
            businessId: this.company.businessId,
          };

          await (this.$root as any)._put(
            `subscriptors/${subscriptorToSave.subscriptor.id}`,
            data
          );
        });

        for (let i in this.company.exclusions) {
          try {
            await (this.$root as any)._post("companiesexclusions", {
              companyId: companyId,
              exclusionId: this.company.exclusions[i].exclusionId,
              percent: this.company.exclusions[i].percent,
            });
          } catch (e) {
            console.log(e);
          }
        }
      }
    } catch (e) {
      console.log(e);
    }

    this.$router.push("/admin/contracts");
  }

  deleteExclusion(exclusion) {
    this.company.exclusions = this.company.exclusions.filter(
      (e) => e.exclusionId !== exclusion.exclusionId
    );
    this.exclusions.push(exclusion);
  }

  async addExclusion() {
    this.company.exclusions.push({
      companyId: null,
      exclusionId: this.exclusion.id,
      title: this.exclusion.title,
      percent: 0,
    });
    this.exclusions = this.exclusions.filter((e) => e.id !== this.exclusion.id);
  }

  async loadExclusions() {
    const response: any = await (this.$root as any)._get("exclusions/all");
    this.exclusions = response.data;
  }

  async loadCurrencies() {
    const response: any = await (this.$root as any)._get("currencies/all");
    this.currencies = response.data;
    this.currencyId = 0;
  }

  async addCurrency() {
    this.currencies = this.currencies.filter((c) => c.id !== this.currency.id);
    this.company.currencies.push({ ...this.currency, can_do_request: true });
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get("branches");
    this.branches = response.data;
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data;
  }

  async loadCompanies() {
    const response: any = await (this.$root as any)._post("companies/all", {
        businessId: this.company.businessId ? this.company.businessId : null,
        businessFilter: this.company.businessId != null && this.company.businessId != ""
    });

    this.companies = response.data;
  }

  async loadBusinesses() {
    const response: any = await (this.$root as any)._post("businesses/all");
    this.businesses = response.data;
  }

  async loadReinsurers() {
    let reinsurers: any = await (this.$root as any)._get(
      "reinsurers"
    );

    let companyReinsurers: any = await (this.$root as any)._get(
      `reinsurerscompanies/${this.$route.params.id}`
    );

    reinsurers = reinsurers.data;
    companyReinsurers = companyReinsurers.data;

    reinsurers.forEach((reinsurer) => {
      companyReinsurers.forEach((companyReinsurer) => {
        if (companyReinsurer.reinsurerId == reinsurer.id) {
          reinsurer.percent = companyReinsurer.percent;
          reinsurer.checked = true;
          reinsurer.branches = JSON.parse(companyReinsurer.branches);
          setTimeout(() => {
            if (reinsurer.branches) {
              reinsurer.branches.forEach((b) => {
                if (typeof b === "object") {
                  let key = Object.keys(b)[0];
                  (document as any).getElementById(
                    `branch-${reinsurer.id}${key}`
                  ).checked = true;
                  (document as any).getElementById(
                    `branch-percent-${reinsurer.id}${key}`
                  ).value = b[key];
                } else {
                  (document as any).getElementById(
                    `branch-${reinsurer.id}${b}`
                  ).checked = true;
                  (document as any).getElementById(
                    `branch-percent-${reinsurer.id}${b}`
                  ).value = 100;
                }
              });
            }
          }, 800);
        }
      });
    });

    this.companyReinsurers = companyReinsurers;
    this.reinsurers = reinsurers;
  }

  async loadCompany() {
    const response: any = await (this.$root as any)._post(
      `companies/one/${this.$route.params.id}`,
      {
        models: "branches,admin",
      }
    );

    this.company = response.data[0];
    this.title = "Actualizar Empresa";
    this.subtitle = "Modifique los datos a actualizar.";
    this.steps[1] = true;
    this.steps[2] = true;
    this.company.handle_exclusion_contract = response.data[0]
      .handle_exclusion_contract
      ? 1
      : 0;

    let datepicker = $("#date_contract_aon")
      .datepicker()
      .data("datepicker");
    let date = moment(this.company.date_contract_aon);

    if (date.isValid()) {
      datepicker.selectDate(date.add(1, "day").toDate());
    }

    datepicker = $("#date_request_from")
      .datepicker()
      .data("datepicker");
    date = moment(this.company.date_request_from);
    if (date.isValid()) {
      datepicker.selectDate(date.add(1, "day").toDate());
    }

    datepicker = $("#date_request_to")
      .datepicker()
      .data("datepicker");
    date = moment(this.company.date_request_to);

    if (date.isValid()) {
      datepicker.selectDate(date.add(1, "day").toDate());
    }

    (this.$refs.selectize as any).$el.selectize.setValue(
      this.company.branches.map((item: any) => {
        return String(item.id);
      })
    );

    this.totalBranches = this.company.branches.map((item: any) => {
      return {
        ...item,
        total: 0,
      };
    });
  }

  calculatePercent() {
    this.totalBranches.forEach((b, index) => {
      this.totalBranches[index].total = 0;
      this.reinsurers.forEach((r, index2) => {
        let checkbox = (document as any).getElementById(
          `branch-${r.id}${b.id}`
        );
        let input = (document as any).getElementById(
          `branch-percent-${r.id}${b.id}`
        );
        if (r.checked && checkbox && checkbox.checked) {
          this.totalBranches[index].total += parseFloat(input.value);
        }
      });
    });
  }

  getSubscriptorName(user: any) {
    if (user.subscriptor.fullname == null || user.subscriptor.fullname.trim() === "") {
      return user.firstName + " " + user.lastName;
    } else {
      return user.subscriptor.fullname;
    }
  }
}
